module.exports = __webpack_public_path__ + "static/media/collection-api-integration.66f33256.png";